import React, { useEffect } from "react";
import { ApolloProvider } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@apollo/client";
import { apolloClient } from "../../GraphQL/clients/accounts-apollo-client";
import { PerfilProvider } from "../../contexts/pages/perfilContext";
import Layout from "../../layouts/layout";
import { useSite } from "../../contexts/siteContext";
import { onError } from "../../GraphQL/helpers";
import { Row, Column } from "../../components/global/grid";
import Seo from "../../components/global/seo";
import Splash from "../../components/global/splash";
import Alert from "../../components/global/alert";
import PageLevelAlert from "../../components/profile/pageLevelAlert";
import ProfileInfo from "../../components/profile/profileInfo";
import AccountInfo from "../../components/profile/accountInfo";
import Emails from "../../components/profile/emails";
import Phones from "../../components/profile/phones";
import Addresses from "../../components/profile/addresses";
import GET_PROFILE from "../../GraphQL/queries/fetchProfile";

const ProfilePage = () => {
  const { t } = useTranslation("pages.perfil");
  const { setAuthenticated } = useSite();
  const { getAccessTokenSilently } = useAuth0();
  const { loading, error, data } = useQuery(GET_PROFILE, {
    context: { getAccessTokenSilently },
    onError: onError(setAuthenticated),
  });

  useEffect(() => {
    if (error) {
      console.log("Error fetching user profile", { ...error });
    }
  }, [error]);

  if (loading) {
    return (
      <Row>
        <Column sm="12" style={{ position: "relative", height: "50vh" }}>
          <Splash />
        </Column>
      </Row>
    );
  }

  if (error) {
    return (
      <Row>
        <Column sm="12">
          <Alert variant="danger" {...t("errors.default", { returnObjects: true })}/>
        </Column>
      </Row>
    );
  }

  if (!data) {
    return <Splash />;
  }

  return (
    <>
      <PageLevelAlert />
      <Row>
        <Column sm="12" md="6" xxl="4">
          <Row>
            <Column sm="12">
              <ProfileInfo user={data.perfil} />
            </Column>
            <Column sm="12">
              <AccountInfo account={data.perfil.cuenta} />
            </Column>
          </Row>
        </Column>
        <Column sm="12" md="6" xxl="8">
          <Row>
            <Column sm="12" xxl="6">
              <Emails emails={data.perfil.emails} />
            </Column>
            <Column sm="12" xxl="6">
              <Phones phones={data.perfil.telefonos} />
            </Column>
            <Column sm="12" xxl="6">
              <Addresses addresses={data.perfil.direcciones} />
            </Column>
          </Row>
        </Column>
      </Row>
    </>
  );
};

const ProfilePageWrapper = (props) => {
  const { t } = useTranslation("pages.perfil");

  return (
    <Layout {...props}>
      <Seo title={t("meta.title")} pageContext={props.pageContext} />
      <ApolloProvider client={apolloClient}>
        <PerfilProvider>
          <ProfilePage {...props} />
        </PerfilProvider>
      </ApolloProvider>
    </Layout>
  );
};

export default ProfilePageWrapper;
